import cx from 'classnames';
import React from 'react';
import { EEventType } from 'types/event-type';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  typeBadge: {
    color: theme.palette.white.main,
    textAlign: 'center',
    padding: '4px 8px',
    borderRadius: '20px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },

  /* NOTE: Prefix must be same as event type eventType w/o spaces */
  AbsenteeOwnersBadge: {
    backgroundColor: theme.palette.absenteeOwners.main,
  },
  NODBadge: {
    backgroundColor: theme.palette.nod.main,
  },
  CommercialBadge: {
    backgroundColor: theme.palette.commercial.main,
  },
  FullFarmBadge: {
    backgroundColor: theme.palette.fullFarm.main,
  },
}));

interface Props {
  eventType: EEventType;
}
const EventTypeBadge: React.FC<Props> = ({ eventType }: Props) => {
  const classes = useStyles();
  let shortenedName: string = eventType;

  if (eventType === EEventType.AbsenteeOwners) shortenedName = 'Absentee';

  return (
    <span className={cx(classes.typeBadge, (classes as any)[`${eventType.replaceAll(' ', '')}Badge`])}>
      {shortenedName}
    </span>
  );
};

export default EventTypeBadge;
